import { render } from "./ListTrashArticleView.vue?vue&type=template&id=07be002c"
import script from "./ListTrashArticleView.vue?vue&type=script&lang=js"
export * from "./ListTrashArticleView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__